import { render, staticRenderFns } from "./JDproprietaryStockImport.vue?vue&type=template&id=8d8cc050&scoped=true&"
import script from "./JDproprietaryStockImport.vue?vue&type=script&lang=js&"
export * from "./JDproprietaryStockImport.vue?vue&type=script&lang=js&"
import style0 from "./JDproprietaryStockImport.vue?vue&type=style&index=0&id=8d8cc050&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8cc050",
  null
  
)

export default component.exports